(function($) {
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
		$('html').addClass('is--device');
		if(/iPad/i.test(navigator.userAgent)){
			$('html').addClass('is--ipad');
		}
	}
	else{
		$('html').addClass('not--device');
	}

	$(function() {//doc.ready[shorthand] start

    // remove search icon
    $('.search_box').hover(function() {
    	$(this).closest('.search-icon').find('img').hide();
    }, function() {
    	$(this).closest('.search-icon').find('img').show();
    });


    // CAMS PAGE
    if ($(window).width() <= 768) {
      $('.right-sidebar').insertAfter(".free-ship");
    }

    // CAROL ON CAMS PAGE
if( $('.owl-rental').length > 0) {
    $('.owl-rental').owlCarousel({
        loop:true,
        margin:10,
        nav:true,
      dots: false,
        navText: ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    });
  }


if( $('.owl-carousel-cams').length > 0) {
    $('.owl-carousel-cams').owlCarousel({
        loop:true,
        margin:10,
        nav:true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    });

}


       $('a.product-photo-thumb img').each(function() {
        var maxWidth = 100; // Max width for the image
        var maxHeight = 100;    // Max height for the image
        var ratio = 0;  // Used for aspect ratio
        var width = $(this).width();    // Current image width
        var height = $(this).height();  // Current image height

        // Check if the current width is larger than the max
        if(width > maxWidth){
            ratio = maxWidth / width;   // get ratio for scaling image
            $(this).css("width", maxWidth); // Set new width
            $(this).css("height", height * ratio);  // Scale height based on ratio
            height = height * ratio;    // Reset height to match scaled image
            width = width * ratio;    // Reset width to match scaled image
        }

        // Check if current height is larger than max
        if(height > maxHeight){
            ratio = maxHeight / height; // get ratio for scaling image
            $(this).css("height", maxHeight);   // Set new height
            $(this).css("width", width * ratio);    // Scale width based on ratio
            width = width * ratio;    // Reset width to match scaled image
            height = height * ratio;    // Reset height to match scaled image
        }
    });



          // set a variable for the cookie check
          // DISABLED APR 12 2019
           // var check_cookie = $.cookie('reysration');
           var check_cookie = 'active';

          // check whether the cookie is already set for this visitor
          if( check_cookie != 'active' ){
            // if the cookie does not exist do the following:

            // (1) set the cookie so it's there for future visits (including an expiration time in days)
            $.cookie('reysration', 'active', {
              expires: 30,
              path: '/'
            });

            // (2) trigger the fancybox pop up, specifying that it's inline
            $( '#trigger' ).fancybox({
              type: 'inline'
            });
            setTimeout(function () {
             $('#trigger').trigger('click');
              }, 5000);
            // $('#trigger').eq(0).trigger('click'); // make the click event happen on load
          }



//       $("a.fancybox").fancybox();

    // FANCYBOX WETSUIT
     $("a.fancybox-wetsuit").fancybox();

    // SIDEBAR MOBILE

	if ($(window).width() <= 767) {

		$('.template-collection .section-header--title').insertBefore('.categories-list:first-child');

		$('.categories-list h4').css('cursor', 'pointer');
		$('.categories-list ul').hide();
		$('.categories-list h4').prepend('<i class="fa fa-chevron-down" style="font-size:16px;margin-right:5px"></i>');
		$('.categories-list h4').click(function(event) {
			$(this).next('ul').toggle();

		});

    $('.product-tabs').insertAfter('h1.product-title').css('margin-bottom','20px');


	}





	  $('.header-main-mobile .search-icon').click(function(event) {
	  	event.preventDefault();
		$('.mobile-search').toggle();
	  });

	  $('.close-search').click(function(event) {
	  event.preventDefault();
	  $('.mobile-search').hide();
	  });

			// NO COOKIE POPUP
			$( '#trigger' ).fancybox({
				type: 'inline',
                  tpl: {
        		  closeBtn: '<a title="Close" class="fancybox-item fancybox-close myClose fa " href="javascript:;">X</a>'
    			}
			});


	    $('.product-sharing a').click(function() {
	           window.open($(this).attr('href'),'title', 'width=500, height=600');
	           return false;
	       });


		// INSTAFEED
		if ( $('#instafeed').length>0 ) {


	    var userFeed = new Instafeed({
	         get: 'user',
	         userId: 176289522,
	         accessToken: '176289522.7325ffe.224bddabec1a4291b44ac363f7a000c4',
         	 template: '<a href="{{link}}" target="_blank" style="background-image: url({{image}});"></a>',
			resolution: 'standard_resolution',
			sortBy: 'most-recent',
			limit: 5
	     });
	     userFeed.run();
 		}


		 // BLOG LOAD MORE



	 load_more_blog = $("#blog-post .blog-area div.blog-post-block").size();
	     x=6;


		 if (load_more_blog <= 6 ){
			 $('#blog-post .load-more-post').hide();
		 }
	     $('#blog-post .blog-area div.blog-post-block:lt('+x+')').show();
	     $('#blog-post .load-more-post').click(function (event) {
			 event.preventDefault();
	         x= (x+3 <= load_more_blog) ? x+3 : load_more_blog;
	         $('.blog-post-block:lt('+x+')').fadeIn(1800);
	         if(x >= load_more_blog){
	         	$(this).hide();
	         }
	     });

	 //load more things HOME PAGE

		 load_more = $(".blog-area div.blog-post-block, .blog-post-layout div.blog-post-block").size();
		     x=3;


			 if (load_more <= 3 ){
				 $('.load-more-post').hide();
			 }

		     $('.blog-area div.blog-post-block:lt('+x+')').show();
		     $('.load-more-post').click(function (event) {
				 event.preventDefault();
		         x= (x+3 <= load_more) ? x+3 : load_more;
		         $('.blog-post-block:lt('+x+')').fadeIn(1800);
		         if(x >= load_more){
		         	$(this).hide();
		         }
		     });





		//Add/Remove Off-Canvas Menu Classes
		var removeClass = true;
		$(".menu-trigger").click(function () {
			$("body").toggleClass('menu-is-open');
			removeClass = false;
		});

		$("nav").click(function() {
			removeClass = false;
		});

		$("html, .close-menu").click(function () {
			if (removeClass) {
				$("body").removeClass('menu-is-open');
			}
			removeClass = true;
		});

		//Insert Nav Dropdown Button
		$("<span class=\"nav-dropdown-button\"></span>").insertAfter(".menu-item-has-children > a");


		//Make the mobile menu work when switching between sizes
		$(window).on("load resize",function(e){
			if ($("html").hasClass("is--device") || $(window).width() <= 979) {
				$(".menu").addClass("mobile-menu");
			}
			else{
				$(".menu").removeClass("mobile-menu");
			}

			if ($("html").hasClass("is--device") || $(window).width() <= 979) {
				$('.mobile-menu ul.sub-menu').hide();
				$('.mobile-menu > li.menu-item-has-children > .nav-dropdown-button, .mobile-menu .sub-menu > li.menu-item-has-children > .nav-dropdown-button').unbind('click');
				$('.mobile-menu > li.menu-item-has-children > .nav-dropdown-button, .mobile-menu .sub-menu > li.menu-item-has-children > .nav-dropdown-button').on('click' , function(e){
					e.preventDefault();
					var el = $(this);
					el.parent().toggleClass('menu-open');
					console.log(this);
					el.next().find('ul.sub-menu').addClass('test');
				});



			}
			else{
				$('.menu > li.menu-item-has-children > a, .menu .sub-menu > li.menu-item-has-children > a').unbind('click');
				$('ul.sub-menu, .menu').removeAttr('style');


			}

			// MAKES BG GRAY FOR FONE IN HOME BLOCK

			// if ($("html").hasClass("is--device") || $(window).width() <= 767) {
			// 	$('.home-block .row .block').not('.mens-block, .womens-block').each(function(index) {
			// 		$(this).addClass('force-background');
			// 	});
			// }
			// else {
			// 	$('.home-block .row .block').not('.mens-block, .womens-block').each(function(index) {
			// 		$(this).removeClass('force-background');
			// 	});
			// }
		});

		//make dropdown button same height as #menu-main a

		var menuButtonHeight = $(".menu > li.menu-item-has-children > a").outerHeight();
		$('.nav-dropdown-button').css({
			'height': menuButtonHeight + 'px'
		});


if ($('.home-slideshow').length > 0) {
		$('.home-slideshow').owlCarousel({
			items : 1,
            autoplay: 3000, //Set AutoPlay to 3 seconds
			singleItem : false,
			itemsScaleUp : true,
			nav:true
		});
		// $('.home-slideshow').owlCarousel({
		//     loop:false,
		//     nav:true
		// })
}

if ($('.notices-slideshow').length > 0) {

		$('.notices-slideshow').owlCarousel({
		    loop:true,
		    margin:0,
		    nav:true,
		    dots:false,
		    items: 1,
		    autoplay: false,
		});

}

	var Desktop = Harvey.attach('screen and (max-width:767px)', {
	  //setup: setup_function, // called when the query becomes valid for the first time
	  on: function(){
	  	$('.brands-list ul').hide();
	  	$('.brands-list h4').on('click',function (e){

	  		e.preventDefault();
	  		$(this).next().slideToggle();

	  	});
	  	//alert('mobile');
	  }, // called each time the query is activated
	  off: function(){
	  	$('.brands-list h4').unbind('click');
	  	$('.brands-list ul').removeAttr('style');
	  } // called each time the query is deactivated
	});



// SWAP THUMB IMAGE


	  if ( $(".product-photo-thumb").length ) {
	    // Switch the main image with one of the thumbnails
	    // Note: this does not change the variant selected, just the image
	    $(".product-photo-thumb").on('click', function(evt) {
	      evt.preventDefault();
	      var newImage = $(this).attr('href');
	      timber.switchImage(newImage, null, timber.cache.$productImage);
	    });
	  }


	timber.switchImage = function (src, imgObject, el) {
	  // Make sure element is a jquery object
	  var $el = $(el);
	  $el.attr('src', src);


	    // Update new image src to grande
	    var zoomSrc = src.replace('_medium.','_1024x1024.').replace('_large.','_1024x1024.');
	    $el.attr('data-zoom', zoomSrc);

	    timber.productImageZoom();

	};


	var swatchcount = $('.spf-product__info .spf-product__swatchs .spf-product__swatch ').length;
	console.log(swatchcount)



	// /* get the mean height of all product items */
	// var isProcutlength = $('.products-grid .is-product .product-grid-image').length;
	// function _imgMinHeight(){
	// 	if($(window).width() <= 767){
	// 		setTimeout(function() {
	// 			$('.products-grid .is-product .product-grid-image').removeAttr('style');
	// 		}, 1300);
	// 	}
	// 	else{
	// 		var maxHeight = [];
	// 		$('.products-grid .is-product .product-grid-image').each(function (i , e){
	// 			$(this).removeAttr('style');
	// 			var el = $(this);
	// 			var c = (i+1);
	// 			maxHeight.push( el.height() );
	// 			if(c >= isProcutlength){
	// 				imgMinHeight = Math.max.apply(null, maxHeight);
	// 				$('.products-grid .is-product .product-grid-image').css({'min-height':imgMinHeight+'px'});

	// 			}
	// 		});
	// 	}
	// }
	// _imgMinHeight();
	// $( window ).resize(function() {
 //  		_imgMinHeight();
	// });


	});// end of doc.ready
})(jQuery);